const { SimpleErrorReport } = require('@nrk/dh-simple-error-report')

function createErrorReporter(name, isErrorReportingEnabled, url) {
  return new SimpleErrorReport({
    name,
    url,
    dryRun: !isErrorReportingEnabled,
  })
}

module.exports.createErrorReporter = createErrorReporter
